
import { WorkStepDto } from "@/dtos/workStepDto";
import { Component, Prop, Vue } from "vue-property-decorator";
import PriceModelDefault, { PriceModel } from "@/dtos/priceModel";

@Component({})
export default class OrderCalculationComponent extends Vue {
	@Prop()
	private show!: boolean;
	@Prop()
	private orderWorkSteps!: any;
	@Prop()
	private articleMaterials!: Map<number, string>;
	private getPriceModelText = PriceModelDefault.getPriceModelText;
	private allPriceModels = PriceModelDefault.allPriceModels;

	private getPriceModel(enumValue: number) {
		return this.allPriceModels[enumValue].value;
	}

	private getStepsGroupedByPriceSetting(steps: WorkStepDto[]) {
		var groupBy = (xs: any, key: any) => {
			return xs.reduce((rv: any, x: any) => {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		};
		let grouped = Object.entries(groupBy(steps, "priceModel"));
		return grouped;
	}

	private getArticleMaterial(articleId: number) {
		return this.articleMaterials.get(articleId);
	}

	private getCustomerPrice(worksteps: WorkStepDto[]) {
		return worksteps.reduce((sum: any, workstep: WorkStepDto) => {
			return sum + workstep.cost;
		}, 0);
	}

	private getManufacturerPrice(worksteps: WorkStepDto[]) {
		return worksteps.reduce((sum: any, workstep: WorkStepDto) => {
			return sum + workstep.manufacturerPrice;
		}, 0);
	}

	private close() {
		this.$emit("close");
	}
}
